import React from 'react';
import Select from './Select';
import { typesOfSaleStatistic } from './constants';

const SaleStatisticsTypeSelect = ({ selectedType, setSelectedType }) => {
  return (
      <Select
        options={typesOfSaleStatistic}
        value={selectedType || ''}
        onChange={(k) => setSelectedType(k)}
        placeholder="statistic.daily"
        infoLabel={'salesFilters.Statistics type'}
      />

  );
};

export default SaleStatisticsTypeSelect;